// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Email } from './email';
import { Manufacturer } from './manufacturer';
import { PoDetailCancel } from './po-detail-cancel';
import { PoHeader } from './po-header';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class PoCancelRequestQueue extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Int32 key */
  id!: number;
  /** Int32 FK email */
  emailId?: number;
  /** Int32 FK manufacturer */
  manufacturerId!: number;
  /** String(200) */
  manufacturerName!: string;
  /** DateTimeOffset FK poDetail */
  poDetailCancelCrtnTs!: Date;
  /** Int32 FK poDetail */
  poDetailId!: number;
  /** Int32 FK poHeader */
  poHeaderId!: number;
  /** String(4) */
  queuedByUserInit?: string;
  /** DateTimeOffset */
  queuedTs!: Date;
  /** DateTimeOffset */
  sentTs?: Date;
  /** String(20) */
  statusId!: string;
  /** FK emailId */
  email!: Email;
  /** FK manufacturerId */
  manufacturer!: Manufacturer;
  /** FK poDetailId,poDetailCancelCrtnTs */
  poDetail!: PoDetailCancel;
  /** FK poHeaderId */
  poHeader!: PoHeader;
}

